<template>
    <div style="height:auto; width: auto;" class="no-margin no-padding">
      <q-card :style="`height: ${height}px; width: 100%;`">
        <iframe id="pdf" title="Manual de uso" :style="`height: ${height}px; width: 100%;`"
          src="ConsultaEstoque-v1.pdf" frameborder="1" scrolling="auto" class="no-margin no-padding"/>
      </q-card>
    </div>
  </template>
  
  <script>
  export default {
    name: "PageManual",
    computed: {
        height() {
            // 56.6 é a altura do header, descontado do tamanho da tela
            return this.$q.screen.height - 55.6
        }
    },
  };
  </script>
